import { render } from "./Settings.vue?vue&type=template&id=219cb02f"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
script.render = render

export default script